import React, { useState } from 'react';

import Button from '../../Button/Button';
import Signature from '../../Signature/Signature';
import Modal from '../Modal';

const SignatureModal = ({ showSignatureModal, hideSignatureModal, onSign = () => {} }) => {
  const [signature, setSignature] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleClose = () => {
    if (isSubmitting) return;
    setSignature(null);
    hideSignatureModal();
  };

  const handleConfirm = async () => {
    if (!signature || isSubmitting) return;
    setIsSubmitting(true);
    try {
      await onSign(signature);
      setIsSubmitting(false);
      handleClose();
    } catch (error) {
      console.error(error);
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      handleOpen={showSignatureModal}
      handleClose={handleClose}
      title="Sign here"
      shouldCloseOnOverlayClick={false}
      footer={
        <>
          <Button variant="tertiary" text="Cancel" size="small" onClick={handleClose} />
          <Button
            text="Sign & Continue"
            isDisabled={!signature}
            isLoading={isSubmitting}
            onClick={handleConfirm}
            size="small"
          />
        </>
      }>
      <Signature value={signature} onChange={setSignature} canvasHeight={200} />
    </Modal>
  );
};

export default SignatureModal;
